import { T_ } from '@shared/translation';
import GoogleMapsLoader from 'google-maps';
import jQuery from 'jquery';

GoogleMapsLoader.KEY = 'AIzaSyBw02hy_J2Gu0rjqv4ZxtnG0rnqzG764oE';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

export default function createLocationField(
  locationForm,
  locationField,
  getLocationButton,
  form,
  validator,
) {
  let selectedFromSuggestions = false;

  function onInputChange(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    } else {
      selectedFromSuggestions = false;
    }
    event.stopPropagation();
  }

  locationField.addEventListener('keydown', onInputChange);
  locationField.addEventListener('keyup', onInputChange);
  locationField.addEventListener('keypress', onInputChange);

  function clearForm() {
    form.project_geoInfo_lat.value = '';
    form.project_geoInfo_lng.value = '';
    form.project_geoInfo_vicinity.value = '';
    form.project_geoInfo_administrative_area_level_1.value = '';
    form.project_geoInfo_country.value = '';
    form.project_geoInfo_formatted_address.value = '';
    form.project_type.value = '';
  }

  function getGeoInfo(place) {
    function extractComponent(type, part) {
      const component = place.address_components.find(
        component => type === component.types[0],
      );
      return component ? component[part] : '';
    }

    const administrativeAreaLevel1 = extractComponent(
      'administrative_area_level_1',
      'short_name',
    );
    const country = extractComponent('country', 'long_name');
    const locality = extractComponent('locality', 'long_name');
    return {
      administrative_area_level_1: administrativeAreaLevel1,
      country,
      locality,
      formatted_address: place.formatted_address,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      vicinity:
        place.vicinity || locality || administrativeAreaLevel1 || country || '',
    };
  }

  function updateGeoInfo(place) {
    selectedFromSuggestions = true;
    if (validator.element(locationField)) {
      const location = getGeoInfo(place);
      form.project_geoInfo_lat.value = location.lat;
      form.project_geoInfo_lng.value = location.lng;
      form.project_geoInfo_vicinity.value = location.vicinity;
      form.project_geoInfo_administrative_area_level_1.value =
        location.administrative_area_level_1;
      form.project_geoInfo_country.value = location.country;
      form.project_geoInfo_formatted_address.value = location.formatted_address;
      form.project_type.value = 'in-person';
    } else {
      clearForm();
    }
  }

  function initAutoCompleteField(google) {
    const gMaps = google.maps;
    const autoComplete = new gMaps.places.Autocomplete(locationField, {});
    jQuery.validator.addMethod('hasValidLocation', () =>
      hasValidLocation(autoComplete.getPlace()),
    );

    function useGeoInfoFromCoordinates(position) {
      const geocoder = new gMaps.Geocoder();
      const { latitude, longitude } = position.coords;
      const latlng = new gMaps.LatLng(latitude, longitude);
      geocoder.geocode({ latLng: latlng }, (results, status) => {
        if (status === gMaps.GeocoderStatus.OK) {
          const currentPlace = results[0];
          locationField.value = currentPlace.formatted_address;
          autoComplete.set('place', currentPlace);
        }
      });
    }

    function useCurrentLocation() {
      if (navigator.geolocation) {
        const geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        };
        navigator.geolocation.getCurrentPosition(
          useGeoInfoFromCoordinates,
          () => {},
          geoOptions,
        );
      }
    }

    function updateGeoInfoUsingPlace() {
      updateGeoInfo(autoComplete.getPlace());
    }

    getLocationButton.addEventListener('click', useCurrentLocation);
    autoComplete.addListener('place_changed', updateGeoInfoUsingPlace);
  }

  function hasValidLocation(place) {
    return selectedFromSuggestions && place && place.place_id;
  }

  function show() {
    jQuery(locationField).rules('add', {
      hasValidLocation: true,
      messages: {
        hasValidLocation: T_('Please select a location from the dropdown'),
      },
    });
    locationForm.classList.remove('is-hidden');
  }

  function hide() {
    clearForm();
    selectedFromSuggestions = false;
    jQuery(locationField).rules('remove', 'hasValidLocation');
    locationForm.classList.add('is-hidden');
  }

  GoogleMapsLoader.load(initAutoCompleteField);
  return {
    show,
    hide,
  };
}
